import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message/section-message';

const i18n = defineMessages({
	errorMessageTitle: {
		id: 'home.welcomeMessage.error.message.title',
		defaultMessage: 'We can’t load your site’s welcome message',
		description: 'Title shown when the site welcome message fails to load',
	},
	errorMessageDescription: {
		id: 'home.welcomeMessage.error.message.description',
		defaultMessage: 'Refresh, or try again later.',
		description: 'Instruction shown when the welcome message fails to load',
	},
});

export const WelcomeMessageError = () => (
	<SectionMessage appearance="warning">
		<Text as="strong">
			<FormattedMessage {...i18n.errorMessageTitle} />
		</Text>
		<Text as="p">
			<FormattedMessage {...i18n.errorMessageDescription} />
		</Text>
	</SectionMessage>
);
